/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-05-29 10:25:33
 * @LastEditTime: 2025-06-09 14:09:59
 */
import arrowRight from '../../images/arrow-right.svg'

const MatchInfo = () => {
  return (
    <>
      <div
        className="jury__line outlineTitle"
        style={{
          textAlign: 'center',
          marginBottom: '60px',
          marginTop: '128px',
        }}>
        <label className={`enter_label  active `}>大赛简介</label>
      </div>
      <div className="home-row row-padding">
        {/* <div className="home-v2-infoLogo">
                    <img src={headerLogo}/>
                </div> */}
        {/* <div className="home-v2-infoSummary">
          为促进上海市知识产权高质量创造，为优质专利项目提供更好的交易服务，推动知识产权和科技成果产权交易的高效运用，由
          <span className="highLight">上海市知识产权局</span>、
          <span className="highLight">上海市科学技术委员会</span>
          主办，
          <span className="highLight">上海技术交易所</span>、
          <span className="highLight">上海市高校科技发展中心</span>、
          <span className="highLight">上海市知识产权服务中心</span>
          联合承办 ， <span className="highLight">上海市科技创业中心</span>
          支持，上海各区知识产权管理部门协办的2022上海市高价值专利运营大赛。旨在挖掘一批创新程度高、市场竞争力强、专利优势明显的专利运营项目以及一批可开放许可的优质专利，以推动上海高校院所、医疗卫生机构、企业等的专利转移转化工作，充分释放和大力彰显专利资源的经济效益和社会效应，为上海经济社会高质量发展注入新动能、塑造新优势。
        </div> */}
        <div className="home-v2-infoSummary">
          上海高价值专利运营大赛（以下简称“上高赛”）是全国首个聚焦“运营”的专利大赛，自2022年启动以来，已经挖掘一批质量高、优势明显的专利运营项目，并取得显著成果：累计吸引485家创新主体参赛，达成交易超11.4亿元，知识产权质押融资近10亿元。2025年，上高赛再次启动，以赛事为契机，以赛程为链条，以服务为亮点，旨在挖掘一批创新程度高、市场竞争力强、专利优势明显的专利运营项目，以推动高校院所、企业的专利转移转化工作，充分释放并彰显专利资源的经济效益与社会价值，成为吸引汇聚高价值专利在上海转化的重要平台，为上海经济社会高质量发展注入新动能、塑造新优势。
        </div>
      </div>
      <div className="home-row">
        <div
          onClick={() => {
            window.location.href = '/schedule'
          }}
          className="link-detail container-linkDetail">
          <img src={arrowRight} />
          了解大赛详情
        </div>
      </div>
      {/* <div className="home-row" style={{ marginTop: '64px' }}>
        <div className="home-v2-unit">主办单位</div>
        <div className="home-v2-unit">承办单位</div>
      </div>
      <div
        className="home-row"
        style={{ marginTop: '24px', justifyContent: 'space-between' }}
      >
        <div className="home-v2-unitLogo">
          <img src={unit1} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit2} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit3} />
        </div>
        <div className="home-v2-unitLogo">
          <img src={unit4} />
        </div>
      </div>
      <div
        className="home-row"
        style={{ marginTop: '24px', justifyContent: 'space-between' }}
      >
        <div className="home-v2-text">上海市知识产权局</div>
        <div className="home-v2-text">上海市科学技术委员会</div>
        <div className="home-v2-text">上海技术交易所</div>
        <div className="home-v2-text">上海市高校科技发展中心</div>
      </div> */}
    </>
  )
}

// @ts-ignore
export default MatchInfo
